// extracted by mini-css-extract-plugin
export default {"returnMsgLength":"components-CustomerSupportForms-OtherQuestions-styles__returnMsgLength--zgn5M"};